import { render, staticRenderFns } from "./NewsImage.vue?vue&type=template&id=2eaa24b4&"
import script from "./NewsImage.vue?vue&type=script&lang=js&"
export * from "./NewsImage.vue?vue&type=script&lang=js&"
import style0 from "./NewsImage.vue?vue&type=style&index=0&id=2eaa24b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports